import {connect} from "react-redux";
import CostEntryComponent from "../../components/CostEntryComponent";
import {costFormValidation} from "../actions/cost";
const stateToProps = (state,ownProps) => {
  return {
    employeeInfo:state.login.employeeInfo,
    managers:state.managers.managers,
    costTypes:state.login.employeeInfo.costType,
    costDocumentationTypes:state.login.employeeInfo.costDocumentationType,
    paymentTypes:state.login.employeeInfo.paymentType,
    costMoneyType:state.login.employeeInfo.costMoneyType,
    kdvOrani:state.login.employeeInfo.kdvOrani,
    kdvOraniAktif:state.login.employeeInfo.kdvOraniAktif,
    maxCostTime:state.login.employeeInfo.maxCostTime,
    permission:state.login.employeeInfo.permission,
    managerRequestCount: state.managers.data.length
  }
};
const dispatchToProps = (dispatch) => {
  return {
    costAddButtonAction:(costData,token,sendToConfirmation,cb,employeeInformation) => {
      dispatch(costFormValidation({
        costFormData: costData,
        token: token,
        status: false,
        sendToConfirmation: sendToConfirmation,
        cb: cb,
        employeeInformation: employeeInformation
      }));
    }
  };
};
const CostEntry = connect(stateToProps,dispatchToProps)(CostEntryComponent);
export default CostEntry;
